module.exports = __webpack_public_path__ + "Unhealthy.f8d2d43a671f3f60c1b29eea77cb921f.hashedasset.svg";